import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

export default class ConsentText extends Component {
  static propTypes = {
    text: PropTypes.string
  };
  render() {
    const { text } = this.props;

    return (
      <Fragment>
        <div className="consent-wrapper">
          <div
            className="consent-text"
            dangerouslySetInnerHTML={{
              __html: text
            }}
          />
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/general-info/consent-text.js